import {getDateFormat, SystemLocales} from "~src/interfaces/session.types";
import {useSelector} from "react-redux";
import {StoreI} from "~src/rootReducer";
import {getSystemLocale} from "~src/services/session";
import moment, {MomentInput} from "moment";

type DateFormatter = (date: MomentInput) => string;

export function useDateFormatter(): DateFormatter {
  const systemLocale: SystemLocales = useSelector((state: StoreI) => getSystemLocale(state));
  const dateFormat = getDateFormat(systemLocale);

  return function dateFormatter(date: MomentInput): string {
    if (!date) {
      return '';
    }
    return moment(date).format(dateFormat);
  }
}

export function useIsoDateFormatter() {
  return (date: MomentInput) => {
    if (!date) {
      return '';
    }
    return moment(date).format('YYYY-MM-DD');
  };
}
